<div class="card">
  <div class="card-body">
    <div class="tenant-project-board-body-table">
      @if (isLoadingResults || isRateLimitReached) {
        <div class="example-loading-shade">
          @if (isLoadingResults) {
            <mat-spinner></mat-spinner>
          }
          @if (isRateLimitReached) {
            <div class="example-rate-limit-reached">
              Squirrel's API rate limit has been reached. It will be reset in one minute.
            </div>
          }
        </div>
      }
      <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: calc(100vh - 430px);  padding: 0px;"
        [overlayLoadingTemplate]="overlayLoadingTemplate"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        [components]="components">
      </ag-grid-angular>
    </div>
  </div>
</div>